// src/App.js
import React from 'react';
import useMeta from '../../hooks/useMeta';

import Navbar from '../../CommonComponent/Navbar/Navbar'; // Importing the Navbar component
import Footer from '../../CommonComponent/Footer/footer';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';



//page component
import SpecialSolutions_PageContent from './PageComponent/SpecialSolutions_PageContent';

function SpecialSolutions() {

  useMeta({
    title: 'Special Solutions for Challenging Architectural Designed Windows',
    description: 'Callistus Window Blinds provides solution for sloped and inclined glass surfaces, patio roofs and asymmetrical conservatory glazing',
    canonical: 'https://callistusblinds.com/special-solutions/',
    og: {
      locale: 'en_US',
      type: 'article',
      title: 'Special Solutions for Challenging Architectural Designed Windows',
      description:
        'Callistus Window Blinds provides solution for sloped and inclined glass surfaces, patio roofs and asymmetrical conservatory glazing',
      url: 'https://callistusblinds.com/special-solutions/',
      site_name: 'Callistus Blinds',
    },
  });

  return (
    <div>
      <Navbar />
      <NotificationBar />
      <SpecialSolutions_PageContent />
      <Footer />
    </div>
  );
}

export default SpecialSolutions;
